import React from 'react';
import { SortContext } from './sortContextProvider';
import { ArticleTileContext } from './articleTileContext';
import { ISortContext } from './sortContextProvider.d';
import { IArticleTileContext } from './articleTileContext';

export const MultipleContext = React.createContext<{ context1: ISortContext, context2: IArticleTileContext }>(
    { context1: null, context2: null }
);

export default function MultipleContextProvider(props: React.PropsWithChildren<object>) {
    return (
        <SortContext.Consumer>
            {context1 => (
                <ArticleTileContext.Consumer>
                    {context2 => (
                        <MultipleContext.Provider value={{ context1, context2 }}>
                            {props.children}
                        </MultipleContext.Provider>
                    )}
                </ArticleTileContext.Consumer>
            )}
        </SortContext.Consumer>
    );
}

